import { useContext, useCallback } from "react";
import { IntlContext, Language } from "@app/provider";
import { isValidLanguageValue } from "@app/utils";

export const useSetUserLanguage = () => {
  const { currentLanguage, changeLanguage } = useContext(IntlContext);

  const setUserLanguage = useCallback(
    (language?: Language) => {
      if (
        language &&
        currentLanguage !== language &&
        isValidLanguageValue(language)
      ) {
        changeLanguage(language);
      }
    },
    [currentLanguage, changeLanguage]
  );

  return setUserLanguage;
};
